import React from 'react'
import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Buttonfilled = ({ text = "", onClick }) => {
    return (
        <>
            {text !== "Book an eye exam" || text !== "Send us a message" ? <Button className="hero-btn-primary" onClick={onClick}>{text}</Button> : <Button as={Link} to="/contact" className="hero-btn-primary">{text}</Button>}
        </>

    )
}

export default Buttonfilled